"use client";

import { useState } from "react";
import { motion } from "framer-motion";
import { useForm } from "react-hook-form";
import {
  Upload,
  DollarSign,
  Target,
  User,
  Banknote,
  PiggyBank,
  Route,
} from "lucide-react";

import { Button } from "../../../shadcn/components/ui/Button";
import { Input } from "../../../shadcn/components/ui/Input";
import { Textarea } from "../../../shadcn/components/ui/Textarea";
import { Label } from "../../../shadcn/components/ui/Label";

export default function Donations() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    setIsSubmitting(true);
    // Simulating API call
    await new Promise((resolve) => setTimeout(resolve, 2000));
    console.log(data);
    setIsSubmitting(false);
  };

  return (
    <div className="max-h-full">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="max-w-4xl mx-auto bg-white rounded-lg  overflow-hidden"
      >
        <div className="bg-purple-600 p-6 ">
          <h1 className="text-2xl md:text-3xl font-bold text-white">
            Create New Donation
          </h1>
        </div>
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="p-6 md:p-8 space-y-3"
        >
          <div className="space-y-2">
            <Label htmlFor="title">Title</Label>
            <Input
              id="title"
              {...register("title", { required: "Title is required" })}
              className="w-full pl-10"
              placeholder="Enter donation title"
            />
            {errors.title && (
              <p className="text-red-500 text-sm">{errors.title.message}</p>
            )}
          </div>

          <div className="space-y-2">
            <Label htmlFor="description">Description</Label>
            <Textarea
              id="description"
              {...register("description", {
                required: "Description is required",
              })}
              className="w-full h-32"
              placeholder="Enter donation description"
            />
            {errors.description && (
              <p className="text-red-500 text-sm">
                {errors.description.message}
              </p>
            )}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-2">
              <Label htmlFor="price">Price</Label>
              <div className="relative">
                <DollarSign className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                <Input
                  id="price"
                  type="number"
                  {...register("price", {
                    required: "Price is required",
                    min: 0,
                  })}
                  className="w-full pl-10"
                  placeholder="0.00"
                />
              </div>
              {errors.price && (
                <p className="text-red-500 text-sm">{errors.price.message}</p>
              )}
            </div>

            <div className="space-y-2">
              <Label htmlFor="goalPrice">Goal Price</Label>
              <div className="relative">
                <Target className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                <Input
                  id="goalPrice"
                  type="number"
                  {...register("goalPrice", {
                    required: "Goal price is required",
                    min: 0,
                  })}
                  className="w-full pl-10"
                  placeholder="0.00"
                />
              </div>
              {errors.goalPrice && (
                <p className="text-red-500 text-sm">
                  {errors.goalPrice.message}
                </p>
              )}
            </div>

            <div className="space-y-2">
              <Label htmlFor="Beneficiary">Beneficiary Name</Label>
              <div className="relative">
                <User className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                <Input
                  id="goalPrice"
                  type="string"
                  {...register("goalPrice", {
                    required: "Goal price is required",
                    min: 0,
                  })}
                  className="w-full pl-10"
                  placeholder="John Doe"
                />
              </div>
              {errors.goalPrice && (
                <p className="text-red-500 text-sm">
                  {errors.goalPrice.message}
                </p>
              )}
            </div>

            <div className="space-y-2">
              <Label htmlFor="Bank">Bank Name</Label>
              <div className="relative">
                <Banknote className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                <Input
                  id="goalPrice"
                  type="string"
                  {...register("goalPrice", {
                    required: "Goal price is required",
                    min: 0,
                  })}
                  className="w-full pl-10"
                  placeholder="Stripe"
                />
              </div>
              {errors.goalPrice && (
                <p className="text-red-500 text-sm">
                  {errors.goalPrice.message}
                </p>
              )}
            </div>

            <div className="space-y-2">
              <Label htmlFor="Account">Account Number</Label>
              <div className="relative">
                <PiggyBank className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                <Input
                  id="goalPrice"
                  type="string"
                  {...register("goalPrice", {
                    required: "Goal price is required",
                    min: 0,
                  })}
                  className="w-full pl-10"
                  placeholder="ABC123"
                />
              </div>
              {errors.goalPrice && (
                <p className="text-red-500 text-sm">
                  {errors.goalPrice.message}
                </p>
              )}
            </div>

            <div className="space-y-2">
              <Label htmlFor="Routing">Routing Number</Label>
              <div className="relative">
                {/* Icon positioned absolutely on the left */}
                <Route className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none" />

                {/* Input field with padding to avoid overlapping the icon */}
                <Input
                  id="goalPrice"
                  type="number"
                  {...register("goalPrice", {
                    required: "Goal price is required",
                    min: 0,
                  })}
                  className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 bg-blue-100"
                  placeholder="0.00"
                />
              </div>
              {errors.goalPrice && (
                <p className="text-red-500 text-sm">
                  {errors.goalPrice.message}
                </p>
              )}
            </div>
          </div>

          <div className="space-y-2">
            <Label htmlFor="image">Image</Label>
            <div className="flex items-center justify-center w-full">
              <label
                htmlFor="image"
                className="flex flex-col items-center justify-center w-full h-64 border-2 border-purple-300 border-dashed rounded-lg cursor-pointer bg-purple-50 hover:bg-purple-100 transition-colors duration-300"
              >
                <div className="flex flex-col items-center justify-center pt-5 pb-6">
                  <Upload className="w-10 h-10 mb-3 text-purple-400" />
                  <p className="mb-2 text-sm text-purple-500">
                    <span className="font-semibold">Click to upload</span> or
                    drag and drop
                  </p>
                  <p className="text-xs text-purple-500">
                    SVG, PNG, JPG or GIF (MAX. 800x400px)
                  </p>
                </div>
                <Input
                  id="image"
                  type="file"
                  {...register("image", { required: "Image is required" })}
                  className="hidden"
                  accept="image/*"
                />
              </label>
            </div>
            {errors.image && (
              <p className="text-red-500 text-sm">{errors.image.message}</p>
            )}
          </div>

          <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
            <Button
              type="submit"
              className="w-full bg-purple-600 hover:bg-purple-700 text-white font-bold py-3 rounded-lg transition-colors duration-300"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Creating..." : "Create Donation"}
            </Button>
          </motion.div>
        </form>
      </motion.div>
    </div>
  );
}
